class CartNotification extends HTMLElement {
  constructor() {
    super();

    this.notification = document.getElementById('cart-notification');
    this.onBodyClick = this.handleBodyClick.bind(this);

    this.notification.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelectorAll('button[type="button"]').forEach((closeButton) =>
      closeButton.addEventListener('click', this.close.bind(this))
    );
    this.querySelectorAll('.cart-notification-overlay').forEach((overlay) =>
      overlay.addEventListener('click', this.close.bind(this))
    );

    this.initSwiper();
    CartNotification.setListeners();
  }

  initSwiper() {
    const slider = this.querySelector('.swiper');
    if (slider) {
      const swiper = new Swiper(slider, {
        freeMode: true,
        slidesPerView: 'auto',
        mousewheel: true,
        observer: true,
      });
    }
  }

  static dragStart(e) {
    const _target = e.target;

    if (_target.closest('#cart-notification')) {
      this._pos_y = 0;
      this._dragStartY = e.touches != null ? e.touches[0].clientY : e.clientY;
      this._dragHistory = [
        {
          position: e.clientY,
          time: performance.now(),
        },
      ];
      // console.log('START:', this._dragStartY);
      this.style.transitionDuration = '0ms';
    }
  }

  static dragMove(e) {
    if (this._dragStartY != null) {
      // console.log(e);

      const currentY = e.touches != null ? e.touches[0].clientY : e.clientY;
      this._dragHistory.push({
        position: currentY,
        time: performance.now(),
      });
      if (this._dragHistory.length > 1) {
        const _len = this._dragHistory.length;
        const _point0 = this._dragHistory[_len - 2];
        const _point1 = this._dragHistory[_len - 1];

        const dt_y = _point1.position - _point0.position;
        const dt_time = _point1.time - _point0.time;
      }
      requestAnimationFrame(CartNotification.containerMove.bind(this));
    }
  }

  static containerMove() {
    if (this._dragHistory != null && this._dragHistory.length > 1) {
      const _len = this._dragHistory.length;
      const _point1 = this._dragHistory[_len - 1];
      const pos_target = Math.min(Math.max(-50, _point1.position - this._dragStartY), this.offsetHeight - 40);
      this._pos_y = this._pos_y + (pos_target - this._pos_y) * 0.05;

      this.style.transform = `translateY(${this._pos_y}px)`;
      requestAnimationFrame(CartNotification.containerMove.bind(this));
    }
  }

  static dragEnd(e) {
    if (this._dragHistory != null && this._dragHistory.length > 1) {
      const _len = this._dragHistory.length;
      const _point0 = this._dragHistory[_len - 2];
      const _point1 = this._dragHistory[_len - 1];

      const dt_y = _point1.position - _point0.position;
      const dt_time = _point1.time - _point0.time;
      const speed = dt_y / dt_time;

      this.style.cssText = '';

      if (speed > 0.1 || _point1.position - this._dragStartY > 100) {
        if (typeof document.querySelector('cart-notification').close == 'function') {
          document.querySelector('cart-notification').close();
        }
      }
    }

    // RESET
    this._dragStartY = null;
    this._dragHistory = [];
  }

  static setListeners() {
    const container = document.querySelector('#cart-notification');

    document.addEventListener('touchstart', CartNotification.dragStart.bind(container));
    document.addEventListener('mousedown', CartNotification.dragStart.bind(container));
    document.addEventListener('mousemove', CartNotification.dragMove.bind(container));
    document.addEventListener('touchmove', CartNotification.dragMove.bind(container));
    document.addEventListener('touchend', CartNotification.dragEnd.bind(container));
    document.addEventListener('mouseup', CartNotification.dragEnd.bind(container));
  }

  open() {
    this.notification.classList.add('animate', 'active');

    this.notification.addEventListener(
      'transitionend',
      () => {
        this.notification.focus();
        trapFocus(this.notification);
      },
      { once: true }
    );

    document.body.addEventListener('click', this.onBodyClick);
  }

  close() {
    this.notification.classList.remove('active');
    document.body.removeEventListener('click', this.onBodyClick);

    removeTrapFocus(this.activeElement);
  }

  renderContents(parsedState) {
    this.cartItemKey = parsedState.key;
    this.getSectionsToRender().forEach((section) => {
      try {
        if (document.getElementById(section.id)) {
          document.getElementById(section.id).innerHTML = this.getSectionInnerHTML(
            parsedState.sections[section.id],
            section.selector
          );
        }
      } catch (err) {
        console.log(err);
      }
    });
    this.initSwiper();
    this.open();
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-notification-product',
        selector: `[id="cart-notification-product-${this.cartItemKey}"]`,
      },
      {
        id: 'product-freeshipping',
      },
      {
        id: 'cart-notification-info',
      },
      {
        id: 'cart-notification-button',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  handleBodyClick(evt) {
    const target = evt.target;
    if (target !== this.notification && !target.closest('cart-notification')) {
      const disclosure = target.closest('details-disclosure, bottom-menu');
      this.activeElement = disclosure ? disclosure.querySelector('summary') : null;
      this.close();
    }
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-notification', CartNotification);
